import { createReducer } from "reduxsauce"
import actionCreator from "helpers/actionCreator"
import { Types as ResearchTopicTypes } from "modules/research-topic-root/model"

export const { Types, Creators } = actionCreator("ompnt/modules/home-layout/", {
  setModel: ["id"],
  setHeader: ["header"],
  toggleSettingsMenu: {
    props: ["settingsMenuAnchor"],
    track: ({ settingsMenuAnchor }) => !!settingsMenuAnchor,
    trackType: "sidebar-menu",
    trackPayload: () => ({ item: "settings" }),
  },
  trackSearchIcon: {
    trackType: "sidebar-search",
    track: true,
  },
  trackMenu: {
    props: ["item"],
    trackType: "sidebar-menu",
    track: true,
    trackPayload: ({ item }) => ({ item }),
  },
  toggleLabsMenu: {
    props: ["labsMenuAnchor"],
    track: ({ labsMenuAnchor }) => !!labsMenuAnchor,
    trackType: "sidebar-menu",
    trackPayload: () => ({ item: "labs" }),
  },
})

const DEFAULT_STATE = {
  selectedModelId: null,
  header: {
    key: null,
    info: [],
    menu: null,
    icon: null,
    title: null,
    topnav: null,
    subnav: null,
    actions: {},
  },
  settingsMenuAnchor: null,
  labsMenuAnchor: null,
}

function handleSetModel(state, { id, modelId }) {
  return { ...state, selectedModelId: id || modelId }
}

function handleSetHeader(state, { header: { title, icon, actions, key, info, menu, topnav, subnav, modelId, noShadow } }) {
  return { ...state, header: { title, icon, actions, key, info, menu, topnav, subnav, modelId, noShadow } }
}

function handleToggleSettingsMenu(state, { settingsMenuAnchor }) {
  return { ...state, settingsMenuAnchor }
}

function handleToggleLabsMenu(state, { labsMenuAnchor }) {
  return { ...state, labsMenuAnchor }
}

function handleTrackMenu(state) {
  return { ...state }
}

export default createReducer(DEFAULT_STATE, {
  [Types.SET_MODEL]: handleSetModel,
  [ResearchTopicTypes.SET_MODEL]: handleSetModel,
  [Types.SET_HEADER]: handleSetHeader,
  [Types.TOGGLE_SETTINGS_MENU]: handleToggleSettingsMenu,
  [Types.TOGGLE_LABS_MENU]: handleToggleLabsMenu,
  [Types.TRACK_MENU]: handleTrackMenu,
})
